import * as R from 'ramda';

import { SelectedFilterOption } from 'src/types';

export const isSameFilterOption = (option1: SelectedFilterOption, option2: SelectedFilterOption) =>
  R.equals(option1.filterUid, option2.filterUid) &&
  R.equals(option1.filterOptionUid, option2.filterOptionUid);
